module.exports = __webpack_public_path__ + "static/media/car-building.de80068b.svg";